import React from "react";
import Navbar from "../pagesections/Navbar";
import "./Termhero.css";
import Herocontenta from "../aboutuscomp/Herocontenta";
import TermHeroH from "../aboutuscomp/TermHeroH.jsx";
import TermHeroHero from "../aboutuscomp/TermHeroH.jsx";
import TrusttHero from "../aboutuscomp/TrusttHero.jsx";

function TrustHero() {
  return (
    <>
    <Navbar/>
    
    <div className="hero-sec-small">
        <Navbar/>
        <TrusttHero/>
    </div>
    </>
  );
}

export default TrustHero;
